import { signInWithPopup, signOut } from 'firebase/auth';
import { getFirebaseAuth, getGoogleProvider, isFirebaseConfigured } from '../config/firebase';
import { api } from './api';

export async function loginWithGoogle() {
  if (!isFirebaseConfigured()) {
    throw new Error(
      'Firebase is not configured. Copy admin/.env.example to admin/.env and add your Firebase keys.'
    );
  }

  const auth = getFirebaseAuth();
  const provider = getGoogleProvider();

  if (!auth || !provider) {
    throw new Error('Firebase auth failed to initialize.');
  }

  const result = await signInWithPopup(auth, provider);
  const { user } = result;

  const response = await api.post('/auth/login', {
    email: user.email,
    name: user.displayName || '',
    photoUrl: user.photoURL || '',
    firebaseUid: user.uid,
  }, { loadingMessage: 'Signing in…' });

  localStorage.setItem('authToken', response.token);
  localStorage.setItem('authUser', JSON.stringify(response.user));

  return response;
}

export async function logout() {
  const auth = getFirebaseAuth();
  if (auth) {
    await signOut(auth);
  }
  localStorage.removeItem('authToken');
  localStorage.removeItem('authUser');
}

export function getStoredUser() {
  const raw = localStorage.getItem('authUser');
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function getStoredToken() {
  return localStorage.getItem('authToken');
}
